import type { AdminEmailTemplateRow } from '../../../domain/superadmin/types';
import { EmailTemplateCard } from './EmailTemplateCard';

interface EmailTemplatesGridProps {
    items: AdminEmailTemplateRow[];
    onPreview: (template: AdminEmailTemplateRow) => void;
    onTest: (template: AdminEmailTemplateRow) => void;
}

export function EmailTemplatesGrid({ items, onPreview, onTest }: EmailTemplatesGridProps) {
    if (items.length === 0) {
        return (
            <p className="py-12 text-center text-sm text-muted">
                Nenhum template de e-mail encontrado.
            </p>
        );
    }

    return (
        <section
            className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
            aria-label="Templates de e-mail"
        >
            {items.map((template) => (
                <EmailTemplateCard
                    key={template.key}
                    template={template}
                    onPreview={onPreview}
                    onTest={onTest}
                />
            ))}
        </section>
    );
}
